var React = require('react');

function Info (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"information-button"),React.createElement("path",{"d":"M16 0c-8.837 0-16 7.164-16 16s7.163 16 16 16 16-7.163 16-16c0-8.836-7.163-16-16-16zM16 8c1.105 0 2 0.896 2 2s-0.895 2-2 2-2-0.895-2-2c0-1.104 0.895-2 2-2zM19 24h-6c-0.552 0-1-0.447-1-1s0.448-1 1-1h1v-6h-1c-0.552 0-1-0.447-1-1s0.448-1 1-1h4c0.552 0 1 0.448 1 1v7h1c0.552 0 1 0.448 1 1s-0.448 1-1 1z","key":1})]);
}

Info.defaultProps = {"version":"1.1","width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Info;

Info.default = Info;
